import { useLayoutEffect, useRef } from 'react'
import Box from '@mui/joy/Box'

export const CanvasContainer = ({
    fillPercentage,
    originalWidth,
    originalHeight,
    onResize,
    children,
}) => {
    const containerRef = useRef(null)

    useLayoutEffect(() => {
        const handleResize = () => {
            if (containerRef.current) {
                const fillSize = fillPercentage / 100
                let width = containerRef.current.clientWidth * fillSize
                let height = containerRef.current.clientHeight * fillSize
                let scaleRatio = Math.min(
                    width / originalWidth,
                    height / originalHeight
                )
                let minDimension = Math.min(width, height) // NOTE: this will only work for square canvas
                onResize({
                    width: minDimension,
                    height: minDimension,
                    scale: scaleRatio,
                })
            }
        }

        window.addEventListener('resize', handleResize)
        handleResize()
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return (
        <Box
            ref={containerRef}
            sx={{
                backgroundColor: '#EBECF0',
                display: 'flex',
                flexGrow: 1,
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            {children}
        </Box>
    )
}
